import React from 'react';
import { TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import NumberFormat from 'react-number-format';

function NumberFormatContext({
  fieldSize,
  name,
  label,
  prefix,
  decimalScale = 0,
  centerText = false,
  customError,
  onValueChangeCallback = () => {},
  onBlurCallback = () => {},
  ...rest
}) {
  const {
    getFieldProps, getFieldMeta, setFieldValue, setFieldTouched,
  } = useFormikContext();
  const { onChange, ...fieldProps } = getFieldProps(name);
  const fieldMeta = getFieldMeta(name);

  const textFieldStyle = {
    textAlign: 'center',
  };

  const infoError = fieldMeta.touched && fieldMeta.error;

  const customValue = rest.value ? { ...fieldProps, value: rest.value } : { ...fieldProps };

  return (
    <NumberFormat
      {...rest}
      {...customValue}
      inputProps={{ maxLength: fieldSize, style: centerText ? textFieldStyle : null }}
      fullWidth
      InputLabelProps={{
        style: { pointerEvents: 'auto' },
      }}
      id={name}
      label={label}
      variant="outlined"
      name={name}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={decimalScale}
      fixedDecimalScale
      prefix={prefix}
      onValueChange={(values) => {
        setFieldValue(name, values.floatValue);
        onValueChangeCallback(values.floatValue);
      }}
      onBlur={() => {
        setFieldTouched(name, true);
        onBlurCallback();
      }}
      customInput={TextField}
      error={infoError || customError}
      helperText={infoError}
    />
  );
}

export default NumberFormatContext;
